import { StyleDc } from "@evergis/api";
import { RangeValue } from "@evergis/ui";

// eslint-disable-next-line max-len
import { CLUSTER_CLASSIFY_FILL_COLOR_ATTRIBUTE } from "../../../components/SymbolEditor/components/ClusterSymbolEditor/consts";
import { getLayerDefinition } from "./getLayerDefinition";
import { isLayerService, LayerInfo, LayerType } from "../../../interfaces/resourceInfo";
import { StyleProxy } from "../classification/StyleProxy";
import { isClusterFillColor } from "../../../interfaces/style";

export const getLayerStyle = (layer?: unknown): StyleDc => {
  const emptyStyle: StyleDc = {};

  if (!isLayerService(layer) || !("style" in layer)) {
    return emptyStyle;
  }

  return {
    ...emptyStyle,
    ...((layer as LayerInfo).style || {}),
  };
};

export function getLayerStyleProxy(layer?: LayerType, defaultScaleRange?: RangeValue, resolution?: number): StyleProxy {
  const styleFromLayer = getLayerStyle(layer);
  const layerDefinition = getLayerDefinition(layer as LayerInfo);
  const layerAttributes = Object.keys(layerDefinition.attributes);
  const children = (layer as LayerInfo)?.style?.children;
  const hasSegmentation = !!children?.[0]?.maxResolution;
  let styleProxy: StyleProxy;

  if (resolution && hasSegmentation) {
    const childIndex = children
      ?.sort((a, b) => (a.minResolution < b.minResolution ? -1 : a.minResolution > b.minResolution ? 1 : 0))
      ?.findIndex(({ minResolution, maxResolution }) => minResolution <= resolution && maxResolution >= resolution);

    styleProxy = new StyleProxy(children[childIndex], defaultScaleRange);
  } else {
    styleProxy = new StyleProxy(styleFromLayer, defaultScaleRange);
    styleProxy.classificationManager.remove(
      ({ attribute, parameter }) =>
        !layerAttributes.includes(attribute) &&
        !(isClusterFillColor(styleProxy.symbol, parameter) && attribute === CLUSTER_CLASSIFY_FILL_COLOR_ATTRIBUTE),
    );
  }

  return styleProxy;
}
